import { formatInstant, timeAgo } from '@ampersandbrands/ui';

/**
 * A relative timestamp ("8 days ago") that always carries the full local date
 * and time as a hover tooltip and an accessible label ("Oct 1, 2026, 2:18 PM").
 * Use it anywhere a page would otherwise print `timeAgo(...)` as bare text.
 */
export function RelativeTime({ value, prefix }: { value: string | null | undefined; prefix?: string }) {
  if (!value) return null;
  const relative = timeAgo(value);
  if (!relative) return null;
  const full = formatInstant(value);
  return (
    <time dateTime={value} title={full || undefined} aria-label={full ? `${relative}, ${full}` : undefined}>
      {prefix ? `${prefix} ` : ''}
      {relative}
    </time>
  );
}
